// extracted by mini-css-extract-plugin
export default {"container":"DateChooser_container__DCvuT","dayLabel":"DateChooser_dayLabel__Oh5PV"};